import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import * as Classes from "../../../classes/index"
import { updateArray } from "../../../helpers/index";
import { IWaiver, defaultWaiver } from "../../../classes/index";

export interface StepThreeModel {
    allergySection: Classes.IAllergySection;
    dietarySection: Array<Classes.IDietaryRestriction>;
    medicalConditionsSection: Classes.IMedicalConditionSection;
    specialNeedsSection: Classes.ISpecialNeedsSection;
    immunizations: boolean;
    medicationSection: Classes.IMedicationSection;
    administeringMedication: Classes.IAdministeringMedication;
}

export const defaultStepThreeModel: StepThreeModel = {
    allergySection: Classes.defaultAllergySection,
    dietarySection: Classes.defaultDietaryRestrictionsArray,
    medicalConditionsSection: Classes.defaultMedicalConditionSection,
    specialNeedsSection: Classes.defaultSpecialNeedsSection,
    immunizations: null,
    medicationSection: Classes.defaultMedicationSection,
    administeringMedication: Classes.defaultAdministeringMedication
};

export default function stepFourReducer(state: StepThreeModel = defaultStepThreeModel, action: IAction) {
    switch (action.type) {
        case ActionType.SAVE_ALLERGY_LIST: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let updatedAllergies = updateArray<Classes.IAllergy>(state.allergySection.allergies, idx, data);

            return _.assign({}, state, { allergySection: _.assign({}, state.allergySection, { allergies: updatedAllergies }) });
        }
        case ActionType.SAVE_ALLERGY_LUNCH: {
            return _.assign({}, state, {
                allergySection: _.assign({}, state.allergySection, {
                    allergenFreeLunchGroup: action.value
                })
            });
        }
        case ActionType.SAVE_ALLERGY_EPIPEN: {
            let data: Classes.IFormAnswer = action.value;

            return _.assign({}, state, {
                allergySection: _.assign({}, state.allergySection, {
                    epiPenInformation: _.assign({}, state.allergySection.epiPenInformation, { [data.id]: data.value })
                })
            });
        }

        case ActionType.SAVE_ADMINISTERATCAMP: {
            return _.assign({}, state, {
                medicationSection: _.assign({}, state.medicationSection, {
                    administerAtCamp: action.value
                })
            });
        }

        case ActionType.SAVE_IMMUNIZATION: {
            return _.assign({}, state, { immunizations: action.value });
        }

        case ActionType.ADD_MEDICATION: {
            const currentMedications = state.medicationSection.medications;
            const medicationCount = currentMedications.length;
            // Need to create a brand new object, or else the reference is kept.
            let udpatedMedications = [...currentMedications.slice(0, medicationCount), _.assign({}, Classes.defaultMedication, { key: medicationCount })];

            return _.assign({}, state, {
                medicationSection: _.assign({}, state.medicationSection, {
                    medications: udpatedMedications
                })
            });
        }

        case ActionType.REMOVE_MEDICATION: {
            const idx = action.value as number;

            let siblingsArray: Classes.IMedication[];
            if (idx < state.medicationSection.medications.length) {
                siblingsArray = [...state.medicationSection.medications.slice(0, idx), ...state.medicationSection.medications.slice(idx + 1)];
            } else {
                siblingsArray = [...state.medicationSection.medications.slice(0, state.medicationSection.medications.length - 1)];
            }

            return _.assign({}, state, {
                siblings: siblingsArray
            });
        }

        case ActionType.NO_TO_ALL_ALLERGIES: {
            const updatedAllergies = Classes.defaultAllergies.map(allergy => {
                return _.assign({}, allergy, { selected: false });
            });

            return _.assign({}, state, {
                allergySection: _.assign({}, state.allergySection, {
                    allergies: updatedAllergies
                })
            });
        }

        case ActionType.SAVE_MEDICATION: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let updatedMedications = updateArray<Classes.IMedication>(state.medicationSection.medications, idx, data);

            return _.assign({}, state, {
                medicationSection: _.assign({}, state.medicationSection, { medications: updatedMedications })
            });
        }

        case ActionType.SAVE_EXCLUDED_ACTIVITIES: {
            return _.assign({}, state, {
                medicationSection: _.assign({}, state.medicationSection, {
                    excludedActivities: action.value
                })
            });
        }

        case ActionType.SAVE_MEDICAL_CONDITION: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let updatedConditions = updateArray<Classes.IMedicalCondition>(state.medicalConditionsSection.medicalConditions, idx, data);

            return _.assign({}, state, { medicalConditionsSection: _.assign({}, state.medicalConditionsSection, { medicalConditions: updatedConditions }) });
        }

        case ActionType.SAVE_MEDICAL_CONDITION_DETAILS: {
            let data: Classes.IFormAnswer = action.value;

            return _.assign({}, state, {
                medicalConditionsSection: _.assign({}, state.medicalConditionsSection, { [data.id]: data.value })
            });
        }

        case ActionType.SAVE_SPECIAL_NEEDS: {
            let data: Classes.IFormAnswer = action.value;

            return _.assign({}, state, {
                specialNeedsSection: _.assign({}, state.specialNeedsSection, { [data.id]: data.value })
            });
        }

        case ActionType.SAVE_DIETARY_RESTRICTIONS: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let updatedRestrictions = updateArray<Classes.IDietaryRestriction>(state.dietarySection, idx, data);

            return _.assign({}, state, { dietarySection: updatedRestrictions });
        }
        case ActionType.SAVE_ADMIN_MEDICATION: {
            let medicines: string = action.value;

            return _.assign({}, state, {
                administeringMedication: _.assign({}, state.administeringMedication, { medications: medicines })
            });
        }
        case ActionType.SIGN_AUTHORIZATION: {
            let signature: string = action.value;
            const authorized = signature.length > 0;

            return _.assign({}, state, {
                administeringMedication: _.assign({}, state.administeringMedication, {
                    authorize: authorized,
                    initials: signature
                })
            });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/step-three-reducer.ts